export default function createReducer(initialState, handlers) {
    return (state = initialState, action) =>
        typeof handlers[action.type] === 'function'
            ? handlers[action.type](state, action)
            : state;
}
